import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import API from "../api";
import Header from "./Header";

export default function Login() {
    const [email, setEmail] = useState("");
    const navigate = useNavigate();
    const [password, setPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState('')

    const GOOGLE_AUTH_URL = `${process.env.REACT_APP_API_URL}/auth/google`;


    async function handleSubmit(e) {
        e.preventDefault();
        setErrorMessage('')

        if (email === '' || password === '') {
            setErrorMessage('Please fill all the form')
            return
        }

        const cleanEmail = email.replace(/[<>{}()"'`;$]/g, "").trim();
        const cleanPassword = password.replace(/[<>{}()"'`;$]/g, "").trim();
    
        try {
            const response = await API.post("/login", {
            email: cleanEmail,
            password: cleanPassword
            });

            console.log("✅ Réponse du serveur :", response.data);
            navigate("/dashboard");
        } catch (error) {
            if (error.status === 401) {
                setErrorMessage("Invalid Credentials");
            } else if (error.status === 403) {
                setErrorMessage('Please verify your email address')
            } else {
                setErrorMessage('An error has occurred')
            }
            console.error("❌ Erreur :", error);
        }
    }

    useEffect(() => {
        async function fetchUser() {
            try {
                const response = await API.get("/me");
        
                if (response) {
                navigate("/dashboard");
                }
            } catch (err) {
                if (err.response && err.response.status === 401) {
                navigate("/login");
                } else {
                console.error(err);
                }
            }
            }
        
            fetchUser();
        }, [navigate]);
        

    return (
        <div className="relative min-h-screen bg-[#0D1117] flex items-center justify-center px-4 sm:px-6 lg:px-8">

        <Header />


        {/* Background graphique */}
        <div className="absolute bottom-0 right-0 overflow-hidden lg:inset-y-0">
            <div className="w-auto h-full bg-gradient-to-tr from-[#1F6FEB]/20 to-[#3B82F6]/10 rounded-full transform rotate-45 scale-150"></div>
        </div>
    
        {/* Formulaire */}
        <div className="relative z-10 w-full max-w-md bg-[#161B22] rounded-2xl shadow-[0_0_20px_#3B82F6]/20 p-8 mt-20">
            <h2 className="text-3xl font-bold text-center text-[#E6EDF3] mb-2 font-pj">
                Welcome Back 👋
            </h2>
            <p className="text-center text-[#8B949E] mb-8">
                Log in to your account to continue
            </p>
    
            <form className="space-y-5" onSubmit={handleSubmit}>
                <div>
                    <label className="block text-[#8B949E] mb-1 font-medium">Email</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="w-full px-4 py-3 border border-[#30363D] rounded-xl focus:ring-2 focus:ring-[#1F6FEB] focus:outline-none bg-[#0D1117] text-[#E6EDF3] placeholder-[#6E7681]"
                        placeholder="you@example.com"
                        required
                    />
                </div>
    
                <div>
                    <label className="block text-[#8B949E] mb-1 font-medium">Password</label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="w-full px-4 py-3 border border-[#30363D] rounded-xl focus:ring-2 focus:ring-[#1F6FEB] focus:outline-none bg-[#0D1117] text-[#E6EDF3] placeholder-[#6E7681]"
                        placeholder="••••••••"
                        required
                    />
                </div>
    
                <div className="flex items-center justify-between text-sm mt-2">
                    <Link to="/forgotpassword" className="text-[#8B949E] hover:text-[#1F6FEB]">
                        Forgot password?
                    </Link>
                </div>
    
                <button
                    type="submit"
                    className="w-full py-3 mt-4 text-white bg-[#1F6FEB] hover:bg-[#388BFD] rounded-xl font-semibold transition shadow-[0_0_10px_#1F6FEB]/30"
                >
                    Login
                </button>
            </form>
            <div className="flex flex-col gap-3 mt-4">
        <a
            href={GOOGLE_AUTH_URL}
            className="w-full py-3 flex justify-center items-center text-[#202124] bg-white hover:bg-gray-200 rounded-xl font-semibold transition shadow-[0_0_10px_#FF0000]/30"
        >
            <svg
            className="w-5 h-5 mr-2"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 48 48"
            >
            <path
                fill="#FFC107"
                d="M43.6 20.5H42V20H24v8h11.3C34.6 34 29.5 38 24 38c-7 0-12.7-5.7-12.7-12.7S17 12.6 24 12.6c3.2 0 6 1.2 8.2 3.2l5.8-5.8C34 5.6 29.1 3 24 3 12.4 3 3 12.4 3 24s9.4 21 21 21c11.5 0 21-9.4 21-21 0-1.4-.1-2.8-.4-4.5z"
            />
            <path
                fill="#FF3D00"
                d="M6.3 14.3l6.6 4.8C14 15.3 18.7 12.6 24 12.6c3.2 0 6 1.2 8.2 3.2l5.8-5.8C34 5.6 29.1 3 24 3 16 3 9.1 7 6.3 14.3z"
            />
            <path
                fill="#4CAF50"
                d="M24 45c5.1 0 9.9-1.9 13.5-5.1l-6.2-5c-2 1.4-4.6 2.2-7.3 2.2-5.5 0-10.2-3.9-11.8-9.1l-6.7 5.1C7.9 40.7 15.4 45 24 45z"
            />
            <path
                fill="#1976D2"
                d="M43.6 20.5H42V20H24v8h11.3c-1.1 3-3.5 5.5-6.7 6.8l6.2 5C41.7 34.5 45 29.6 45 24c0-1.4-.1-2.8-.4-4.5z"
            />
            </svg>
            Log in with Google
        </a>
        </div>
    
            <p className="text-center text-[#8B949E] mt-6">
                Don’t have an account?{" "}
                <a href="/register" className="font-semibold text-[#1F6FEB] hover:underline">
                    Register
                </a>
            </p>
            {errorMessage && (
                <p className="text-red-500 text-sm mt-2 text-center">{errorMessage}</p>
            )}
        </div>
    </div>
    
    );
}
